import React from "react";
import "./BestWebLogo.css";

const BestWebLogo = () => {

    return (
        <div>
        <a
          href="https://ebadge.bestweb.lk/api/v1/clicked/hirdaramani-sustainability.lk/BestWeb/2025/Rate_Us"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Rate us on BestWeb 2025"
          className="bestweb-center"
        >
          <img
            src="https://ebadge.bestweb.lk/eBadgeSystem/domainNames/hirdaramani-sustainability.lk/BestWeb/2025/Rate_Us/image.png"
            className="bestweb"
            alt="BestWeb 2025 Rate Us"
            width="200"
            height="125"
          />
        </a>
        <a
          href="https://bestweb.lk/past-winners/?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Rate us on BestWeb 2025"
          className="bestweb-center"
        >
          <img
            src="https://sgp1.digitaloceanspaces.com/hirdaramani-microsite/images/BWGold.webp"
            className="bestweb"
            alt="BestWeb 2025 Gold Winner"
            width="200"
            height="125"
          />
          <img
            src="https://sgp1.digitaloceanspaces.com/hirdaramani-microsite/images/BWMobile.webp"
            className="bestweb"
            alt="BestWeb 2025 Mobile Winner"
            width="200"
            height="125"
          />
        </a>
      </div>
    );
};

export default BestWebLogo;
